module.exports = __webpack_public_path__ + "static/media/21ECLAC22.961b66a6.jpg";